import styled from 'styled-components';
import { media } from 'legacyComponents/styled/styleUtils';

import { Accordion, Button } from 'components';

export const AccordionStyled = styled(Accordion)`
  margin: ${props => props.theme.spacing.default} 0;
`;

export const Version = styled.p`
  display: inline-block;
  margin: 10px 0 0 0;
  ${media.s`
    font-size: 0.9em;
  `}
`;

export const ButtonStyled = styled(Button)`
  margin-bottom: 20px;
  float: right;
  ${media.s`
    transform: scale(0.9);
    margin-right: -4px;
  `}
`;

export const Image = styled.img`
  width: 100%;
  height: auto;
`;

export const Wrapper = styled.div`
  width: 700px;
  margin: 40px auto 120px auto;
  ${media.s`
    width: calc(100% - 30px);
  `}
`;
